__webpack_require__.p = "/blocks/";